import useMessage from '@hooks/useMessage'
import useWebsiteId from '@hooks/useWebsiteId'
import {useMutate} from 'apollo-hooks'
import gql from 'graphql-tag'

export default function useSaveSessionEmail(
  preferences,
  onSessionEmailHasAccount = (email: string) => {},
  setErrorMessage = (message: string) => {}
) {
  const mutate = useMutate()
  const showMessage = useMessage()
  const websiteId = useWebsiteId()

  return async (email: string) => {
    setErrorMessage(null)
    try {
      if (email && !validateEmail(email)) {
        setErrorMessage('El email es inválido')
        return
      }
      if (email === preferences.sessionEmail || (!email && !preferences.sessionEmail)) return
      const {result} = await mutate({
        mutation: gql`
          mutation setUserPreferencesSaveSessionEmail($websiteId: ID, $sessionEmail: String) {
            result: setUserPreferences(websiteId: $websiteId, sessionEmail: $sessionEmail) {
              _id
              websiteId
              sessionEmail
              sessionEmailHasAccount
              sessionEmailHasName
            }
          }
        `,
        variables: {
          websiteId,
          sessionEmail: email
        },
        refetchQueries: ['getMyOrderPreferences', 'getUserPreferences'],
        optimisticResponse: email
          ? null
          : {
              result: {
                ...preferences,
                sessionEmail: null,
                sessionEmailHasAccount: false
              }
            }
      })

      if (email && result.sessionEmailHasAccount) {
        onSessionEmailHasAccount(email)
      }
    } catch (error) {
      showMessage(error)
    }
  }
}

function validateEmail(email) {
  return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email);
}
